import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import axios from 'axios';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
// import map from 'lodash/map';
// import size from 'lodash/size';
// import flatten from 'lodash/flatten';
import { startSetContracts, startAddContract } from '../../actions/contracts';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import { FMessage, iFMessage } from '../../hoc/IntlComponents';
import ContractsOpeningWords from '../../components/Contracts/ContractsOpeningWords';
import ContractsForm from '../../components/Contracts/ContractsForm';
import WithAlert from '../../hoc/WithAlert';
import AddedContracts from '../../components/Contracts/AddedContracts';
import SMSNotificationsModal from '@modals/SMSNotificationsModal/SMSNotificationsModal';
import PaymentPursesListItem from '../../components/Payments/PaymentPursesListItem/PaymentPursesListItem';
import { getSlaveId } from '../../components/Statistics/statisticsHelpers';
import {
  startSetWallets,
  startCreateWallets,
  startDeleteWallets,
  startUpdateWallets,
} from '@actions/wallets';
import {
  startSetSlaveWallets,
  startCreateSlaveWallets,
  startDeleteSlaveWallets,
} from '@actions/slaves';

const types = ['self', 'ip', 'ooo'];

const ZALEYCASH_TYPE = 29;
const ZALEYCASH_USD_TYPE = 36;

class ContractsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 0,
      loading: false,
      errors: {},
      error: false,
      formIsBlurred: false,
      isEditModalOpen: false,

      walletsLoading: false,
      newWalletSMSInputTargetId: null,
      changingInputId: null,
      smsModal: false,
      submitData: null,
      submitCatchCB: null,
      submitThenCB: null,
      newWalletSMSInput: '',
      number: '',

      sessionId: 0,
      authType: null,
      verification_error: null,
      verificationStatus: null,
      validTill: 0,
      transport: 'sms',
    };
  }

  handleTypeChange = (type) => {
    this.setState(() => ({ type }));
  };

  getContracts = () => {
    const { showAlert, startSetContracts } = this.props;
    this.setState({
      loading: true,
      error: false,
    });
    const reqArray = types.map((value, index) => startSetContracts(index));
    axios
      .all(reqArray)
      .catch(({ response }) => {
        if (response && response.data && response.data.error) {
          const { message: error } = response.data.error;
          showAlert({
            alertType: 'danger',
            message: error.message,
            dismissable: true,
          });
          if (error.type === 'api.contracts.gambling_limitation') {
            this.setState({ formIsBlurred: true });
          }
          this.setState(() => ({ error: true }));
        }
      })
      .finally(() => this.setState(() => ({ loading: false })));
  };

  getContractsCount = () => {
    const { contracts } = this.props;
    let count = 0;
    types.forEach((type) => (count += Object.keys(contracts[type]).length));
    return !!count;
  };

  onSubmit = (item) => {
    const { startAddContract, showAlert, intl } = this.props;
    const { type } = this.state;
    this.setState(() => ({ loading: true }));
    startAddContract(type, item)
      .then(() => {
        showAlert({
          alertType: 'success',
          message: iFMessage({ intl, id: 'contracts.alert.add.success' }),
          dismissable: true,
        });
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.error) {
          const { message: error } = response.data.error;
          showAlert({
            alertType: 'danger',
            message: error.message,
            dismissable: true,
          });
        }
      })
      .finally(() => {
        this.setState(() => ({ loading: false }));
      });
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      isEditModalOpen: !prevState.isEditModalOpen,
    }));
  };

  getWallets = () => {
    const { startSetWallets } = this.props;
    this.setState({ walletsLoading: true });
    startSetWallets()
      .catch(({ response = {} }) => this.handleWalletErrorAlerts(response))
      .finally(() => this.setState({ walletsLoading: false }));
  };

  getZaleyCashWallets = () => {
    const { wallets = [], profile } = this.props;
    const showZaleyCashRub = Boolean(profile && profile?.can_use_zaleycash);

    return wallets.filter((w) => {
      if (w.type === ZALEYCASH_TYPE) {
        return showZaleyCashRub;
      }
      return w.type === ZALEYCASH_USD_TYPE;
    });
  };

  handleWalletErrorAlerts = (response) => {
    const { showAlert } = this.props;
    if (response?.data?.error) {
      const { message: error } = response.data.error;
      if (error.type === 'api.security.not_verified') {
        this.setState({ verification_error: error.message });
      } else {
        showAlert({ alertType: 'danger', message: error.message, dismissable: true });
      }
    }
  };

  handleValidate = (regexp, number) => {
    if (Array.isArray(regexp) && regexp.length > 0) {
      const re = new RegExp(...regexp);
      return number.search(re) === -1;
    }
    return false;
  };

  handleChangeNewWalletSMSInputTargetId = (target, id) =>
    this.setState({ newWalletSMSInputTargetId: target, changingInputId: id });

  handleSetVerificationData = (data) => this.setState((prev) => ({ ...prev, ...data }));

  submitCatchCB = () => this.setState({ error: false, newWalletSMSInputError: false });

  submitThenCB = () =>
    this.setState({
      newWalletSMSInputError: false,
      error: false,
      newWalletSMSInput: '',
      number: '',
    });

  handleSubmitWithSMS = ({ submitData, code, submitCatchCB, submitThenCB }) => {
    const { showAlert, startCreateWallets, startUpdateWallets } = this.props;

    let requestData;

    this.setState({ submitData, submitCatchCB, submitThenCB }, () => {
      const { sessionId, authType } = this.state;
      requestData = { ...submitData };
      if (authType) {
        switch (authType) {
          case 1:
            requestData['sms_session_id'] = sessionId;
            requestData['sms_code'] = code;
            break;
          case 2: // google auth
            requestData['token'] = code;
            break;
          case 4: // telegram bot
            requestData['telegram_code'] = code;
            requestData['telegram_session_id'] = sessionId;
            break;
        }
      } else if (sessionId && code) {
        requestData['verification_session_id'] = sessionId;
        requestData['verification_code'] = code;
      }

      const { wallet_id } = requestData;
      const request = wallet_id === null ? startCreateWallets : startUpdateWallets;

      request(requestData)
        .then(() => {
          this.handleSetVerificationData({
            sessionId: '',
            verificationStatus: null,
            verification_error: null,
            validTill: 0,
          });

          this.closeSMSModal();
          submitThenCB ? submitThenCB() : this.state.submitThenCB();
          this.handleChangeNewWalletSMSInputTargetId(null);
          showAlert({
            message: iFMessage({
              intl: this.props.intl,
              id: 'payment-data.wallets.update.success.zaleycash',
            }),
            alertType: 'success',
            dismissable: true,
          });
          this.getWallets();
        })
        .catch((err) => {
          if (err && err.response) {
            const { response } = err.response.data;
            if (response) {
              if (err.response.status === 401) {
                const { verification } = response;
                const { sessionId, validTill, type, transport } = verification;

                submitCatchCB ? submitCatchCB() : this.state.submitCatchCB();

                this.handleSetVerificationData({
                  sessionId,
                  authType: type,
                  status: err.response.status,
                  verification_error: null,
                  changedWalletId: wallet_id,
                  validTill,
                  transport,
                });
                this.openSMSModal();
              } else if (
                err.response.status === 400 &&
                err.response.data.error.message.type === 'api.wallets.wrong_number'
              ) {
                this.handleErrorAlerts(err.response);
                this.setState(() => ({
                  smsModal: false,
                }));
                this.handleSetVerificationData({
                  ...deafaultVerifiationData,
                });
              } else this.handleErrorAlerts(err.response);
            }
          }
        });
    });
  };

  handleSave = (data) => {
    this.setState(() => ({ loading: true }));
    const { startCreateWallets, startCreateSlaveWallets, isMember, showAlert, intl } = this.props;
    const request = startCreateSlaveWallets;
    const params = { ...data };
    if (isMember) {
      params.id = getSlaveId();
    }

    startCreateWallets(data)
      .then(() => {
        showAlert({
          alertType: 'success',
          message: iFMessage({
            intl,
            id: `payment-data.create.success${data.type === 3 ? '.bank' : ''}`,
          }),
          dismissable: true,
          closeInSeconds: 3,
        });
        return this.getWallets();
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;

          this.setState(() => ({
            loading: false,
            modal: true,
            error,
          }));
        }
      });
  };

  handleDelete = (id, type) => {
    const { startDeleteWallets, startDeleteSlaveWallets, showAlert, intl, isMember } = this.props;
    const request = startDeleteSlaveWallets;
    const params = { id };
    if (isMember) {
      params.slaveId = getSlaveId();
    }
    startDeleteWallets({ id })
      .then(() => {
        this.getWallets();
        showAlert({
          alertType: 'success',
          message: iFMessage({
            intl,
            id: `payment-data.delete.success${type === 3 ? '.bank' : ''}`,
          }),
          dismissable: true,
          closeInSeconds: 3,
        });
      })
      .catch(({ response = {} }) => {
        this.handleErrorAlerts(response);
      });
  };

  modalSubmit = (code) => {
    const { submitData, submitCatchCB, submitThenCB } = this.state;
    this.handleSubmitWithSMS({ submitData, submitCatchCB, submitThenCB, code });
  };

  openSMSModal = () => this.setState({ smsModal: true });
  closeSMSModal = () => this.setState({ smsModal: false });
  toggleSMSModal = () =>
    this.setState((prev) => ({
      smsModal: !prev.smsModal,
      sessionId: '',
      verificationStatus: null,
      verification_error: null,
      validTill: 0,
    }));

  componentDidMount() {
    this.getContracts();
    this.getWallets();
  }

  render() {
    const { contracts, showAlert, closeAlert, intl, profile, balance = [] } = this.props;
    const {
      loading,
      walletsLoading,
      type,
      error,
      formIsBlurred,
      isEditModalOpen,
      smsModal,
      sessionId,
      authType,
      verification_error,
      verificationStatus,
      validTill,
      transport,
      newWalletSMSInputTargetId,
    } = this.state;

    const zaleyCashWallets = this.getZaleyCashWallets();
    const rubBalance = balance.find(({ currency }) => currency === 'RUB');
    const isAddRequisitesDisabled = Boolean(rubBalance && Number(rubBalance.balance) < 10000);

    return (
      <Layout formattedTitle="account.payment-requisites">
        <Layout.Col lg={{ size: 12 }} className="contracts-page">
          {/* <ContractsOpeningWords /> */}
          <div className="contracts-wrapper">
            {/* {this.getContractsCount() && ( */}
            <AddedContracts
              contracts={contracts}
              types={types}
              typeIndex={type}
              error={error}
              showAlert={showAlert}
            />
            {/* )} */}
            {zaleyCashWallets.length > 0 && (
              <div
                className="accordion-wrapper zaleycash-wallet-card"
                style={{ minHeight: 'auto' }}
              >
                {zaleyCashWallets.map((wallet) => (
                  <PaymentPursesListItem
                    key={wallet.type}
                    {...wallet}
                    onSavePurse={this.handleSave}
                    onDeletePurse={this.handleDelete}
                    intl={intl}
                    profile={profile}
                    newWalletSMSInputTargetId={newWalletSMSInputTargetId}
                    handleChangeNewWalletSMSInputTargetId={
                      this.handleChangeNewWalletSMSInputTargetId
                    }
                    handleSubmitWithSMS={this.handleSubmitWithSMS}
                    handleValidate={this.handleValidate}
                    submitCatchCB={this.submitCatchCB}
                    submitThenCB={this.submitThenCB}
                    showAlert={showAlert}
                    closeAlert={closeAlert}
                    getWallets={this.getWallets}
                    loading={walletsLoading}
                  />
                ))}
              </div>
            )}
          </div>

          <SMSNotificationsModal
            authType={authType}
            sessionId={sessionId}
            validTill={validTill}
            isOpen={smsModal}
            toggleModal={this.toggleSMSModal}
            onSubmit={(e, code) => this.modalSubmit(code)}
            error={verification_error}
            status={verificationStatus}
            transport={transport}
          />

          <div className="contracts-btn-wrapper">
            <Button
              className="btn btn-sm contracts-btn"
              color="primary"
              disabled={isAddRequisitesDisabled}
              onClick={this.toggleModal}
            >
              <FMessage id={'contracts.details.add.btn'} />
            </Button>
            {isAddRequisitesDisabled && (
              <div className="contracts-btn-hint">
                <FMessage id="contracts.details.add.balance-hint" />
              </div>
            )}
          </div>

          <Modal
            modalClassName="modal-payment-requisites"
            toggle={this.toggleModal}
            isOpen={isEditModalOpen}
            size="lg"
            centered
          >
            <ModalHeader toggle={this.toggleModal}>
              <FMessage id="contracts.modal.new-requisites" />
            </ModalHeader>
            <ModalBody>
              <ContractsForm
                type={type}
                types={types}
                onSubmit={this.onSubmit}
                contracts={contracts}
                // disabled={error}
                handleTypeChange={this.handleTypeChange}
                inModal={false}
                loading={loading}
                isBlurred={formIsBlurred}
                toggleModal={this.toggleModal}
              />
            </ModalBody>
          </Modal>
        </Layout.Col>
      </Layout>
    );
  }
}

const mapStateToProps = ({ contracts, webmaster }) => ({
  contracts,
  wallets: webmaster.wallets,
  profile: webmaster.profile,
  balance: webmaster.balance,
});

const mapDispatchToProps = (dispatch) => ({
  startSetContracts: (type) => dispatch(startSetContracts(types[type])),
  startAddContract: (type, item) => dispatch(startAddContract(types[type], item)),
  // startApproveContract: (contractType, item) => dispatch(startApproveContract(contractType, item)),
  startSetWallets: (params) => dispatch(startSetWallets(params)),
  startCreateWallets: (data) => dispatch(startCreateWallets(data)),
  startDeleteWallets: (params) => dispatch(startDeleteWallets(params)),
  startDeleteSlaveWallets: (params) => dispatch(startDeleteSlaveWallets(params)),
  startUpdateWallets: (data) => dispatch(startUpdateWallets(data)),
  clearRedirectToPaymentsData: () => dispatch(clearRedirectToPaymentsData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithAlert(injectIntl(ContractsPage)));
